import type { ReactNode } from 'react';
import React from 'react';
import type { ModalProps } from 'antd';

import StyledModal from './styled.tsx';

export interface BaseModalProps extends ModalProps {
    open: boolean;
    content: ReactNode;
    footer: ReactNode;
    onClose?: () => void;
    closeIcon?: ReactNode;
    title?: ReactNode;
    onCancel?: () => void;
}

export const BaseModal: React.FC<BaseModalProps> = ({ closeIcon = null, content = null, ...props }) => (
    <StyledModal {...props} closeIcon={closeIcon}>
        {content}
    </StyledModal>
);
